module.exports = __webpack_public_path__ + "static/media/administracion_bco.5ba2ded5.svg";